const STORAGE_KEY = 'last-login-first-name'

/**
 * Remember the first name of the last user to log in on this browser, so the
 * login screen can greet them by name on a future visit.
 *
 * @param {string} firstName
 * @returns {void}
 */
export function rememberFirstName(firstName) {
    if (firstName) {
        localStorage.setItem(STORAGE_KEY, firstName)
    } else {
        forgetFirstName()
    }
}

/**
 * Forget the remembered first name.
 *
 * @returns {void}
 */
export function forgetFirstName() {
    localStorage.removeItem(STORAGE_KEY)
}

/**
 * Retrieve the remembered first name, if any.
 *
 * @returns {string|null}
 */
export function getRememberedFirstName() {
    return localStorage.getItem(STORAGE_KEY)
}
